export const getError = (state) => state.api.errorMessage;
